<script lang="ts" setup>
import { useUserStore } from '@/stores/user';
import { useModalsStore } from '@/stores/modals';
import { useAlertsStore } from '@/stores/alerts';
import { computed } from 'vue';

import { useForm } from 'vee-validate';
import * as yup from 'yup';

import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const { register } = useUserStore();
const { toggleModal, closeModal } = useModalsStore();
const { openMessage } = useAlertsStore();
const router = useRouter();

const emit = defineEmits(['onSubmit']);
const props = defineProps<{
    page: boolean;
}>();

const activeValidation = ref(false);
const validate = computed(() => {
    return yup.object({
        username: yup.string().required(),
        email: yup.string().required().email(),
        password: yup.string().required()
    });
});

const emailFormat = computed( () => {
    email.value = email.value.toLowerCase().replace(/ /g,'');
});

const { errors, useFieldModel, handleSubmit } = useForm({
    validationSchema: validate
});
const [username, email, password, passwordconfirm] = useFieldModel(['username', 'email', 'password']);

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    try {
        emit('onSubmit', true);
        const error = await register(values);
        emit('onSubmit', false);
        activeValidation.value = false;
        if (error) {
            resetForm();
            openMessage({
                content: 'modals.alerts.errorSubmitRegisterForm',
                class: 'error'
            });
        } else {
            resetForm();            
            openMessage({
                content: 'modals.alerts.successSubmitRegisterForm',
                class: 'success'
            });
            router.push({ name: 'grid' });
            closeModal('register');
        }
    } catch (ex) {
        isSubmitting.value = false;
        openMessage({
            content: 'modals.alerts.errorSubmitRegisterForm',
            class: 'error'
        });
    }
});

function doLogin() {
    toggleModal('login');
}
</script>

<template src="./modal-register.html"></template>
